import axios from 'axios';

// Admin endpoints are authorised by the login token axios already sends (see UserContext).
// `userId` params are kept for call-site compatibility.
const admin = () => ({});

export const getAdminStats = async (userId, days = 30) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/stats`, { params: { days }, ...admin(userId) });
    return data;
};

export const getAdminOrders = async (userId) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/orders`, admin(userId));
    return data.orders;
};

export const setAdminOrderStatus = async (userId, orderId, status) => {
    const { data } = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/admin/orders/${orderId}/status`, { status }, admin(userId));
    return data.order;
};

export const resendOrderEmail = async (orderId, event, email) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/orders/${orderId}/email`, { event, email });
    return data;
};

export const getAdminOrdersWithMeta = async () => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/admin/orders`);
    return data;
};

export const shipWithShiprocket = async (orderId) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/orders/${orderId}/shiprocket`);
    return data;
};

export const trackShiprocket = async (orderId) => {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/admin/orders/${orderId}/shiprocket/track`);
    return data;
};
